import React from 'react'
import { useAuth0 } from '../../Hooks/auth0'
import Dashboard from '../Dashboard/index'

const AuthRoute = ( {as: Comp, action, ...props }) => {
    const { profile } = useAuth0()
    const context = 'https://mmg/user_metadata'
    const metadata = profile ? profile[context] : []
    const userActions = metadata && metadata.actions ? metadata.actions : []

    const hasRight = userActions ? userActions.find(a => a === action) : null
    return hasRight ? <Comp {...props} /> : <Dashboard />
}

export default AuthRoute